module.exports = __webpack_public_path__ + "static/media/CF_WebIcons_SpouseProgram_Read.128cf3ae.svg";